import Preview from "./Preview/Preview";


export default {
    id:"PopupView",
    parent:{name:"View"},
    description:"a self-position-adjustment view",
    preview:Preview,
    props:[
        {
            name:"target",
            type:"HTMLElement",
            description:"an element near which the popupview is shown",
        },
        {
            name:"parent",
            type:"HTMLElement",
            description:`
                if target is specified, parent is the element relative to which the PopupView will adjust its position 
                @default document.documentElement
            `,
        },
        {
            name:"avoidable",
            type:"boolean",
            description:"Unmounts the popupview on outside click, default to true",
        },
        {
            name:"keepinDOM",
            type:"boolean",
            description:`
                If true, unmounting will not cleanup the event listeners nor remove the popupview from DOM
                @default to false
            `,
        },
        {
            name:"onUnmount",
            type:"():void",
        },
    ],
    methods:[
        {
            name:"cleanupEventListeners",
            type:"():void",
            description:`
                cleans up the added event listeners
                @Should be called if unmount method is overwritten
            `,
        },
        {
            name:"unmount",
            type:"():void",
            description:"Cleans up the event listeners and removes the popupview from DOM",
        },
    ],
}
